const objectHash = require('object-hash');

/**
 * Generate a hash for a KitchenOrderItem that uniquely represents this item for kitchen purposes.
 * This takes into account the itemID and field data only.
 *
 * @param {KitchenOrderItem} kitchenOrderItem
 *
 * @return {string}
 */
const kitchenOrderItemHash = (kitchenOrderItem) => {
    // For debugging, it can be more useful to have a human-readable string.
    // return JSON.stringify({
    //     itemID: kitchenOrderItem.itemID,
    //     fieldData: kitchenOrderItem.fieldData,
    //     itemOptions: kitchenOrderItem.itemOptions.map((io) => io.key),
    // });

    return objectHash(
        {
            itemID: kitchenOrderItem.itemID,
            fieldData: kitchenOrderItem.fieldData,
            itemOptions: kitchenOrderItem.itemOptions.map((io) => io.key),
        },
        {
            // Sort arrays so the order does not change the hash.
            unorderedArrays: true,

            // Ignore the $$hashKey key that angular may add.
            excludeKeys: (k) => k === '$$hashKey',
        }
    );
};

module.exports = {
    kitchenOrderItemHash,
};
